import UsersList from './UsersList';

export default UsersList;
